module.exports = __webpack_public_path__ + "img/tour-leader-icon.6e9772e2.svg";